<script lang="ts">
	import { page } from "$app/state";
	import type { PublicInvestmentListing } from "@fergmar/contracts/public/investment-listings";
	import type { SalesListingFilters } from "./sale-listings-grid.types";
	import SalesListingCard from "./sales-listing-card.svelte";
	import SalesListingsGrid from "./sales-listings-grid.svelte";

	type PublicListing = PublicInvestmentListing;

	let { listings }: { listings: PublicListing[] } = $props();

	const parseNumber = (value: string | null): number | null => {
		if (!value) return null;
		const parsed = Number(value);
		return isNaN(parsed) ? null : parsed;
	};

	const filters = $derived<SalesListingFilters>({
		minPrice: parseNumber(page.url.searchParams.get("minPrice")),
		maxPrice: parseNumber(page.url.searchParams.get("maxPrice")),
		status: page.url.searchParams.get("status"),
		type: page.url.searchParams.get("type"),
		beds: parseNumber(page.url.searchParams.get("beds")),
		baths: parseNumber(page.url.searchParams.get("baths"))
	});

	const filteredListings = $derived.by(() => {
		if (
			!filters.minPrice &&
			!filters.maxPrice &&
			!filters.status &&
			!filters.type &&
			!filters.beds &&
			!filters.baths
		) {
			return listings;
		}

		return listings.filter((listing) => {
			if (filters.minPrice && listing.currentPrice < filters.minPrice) return false;
			if (filters.maxPrice && listing.currentPrice > filters.maxPrice) return false;

			if (filters.type) {
				const typeParams = filters.type.split(",").map((t) => t.trim());
				if (!typeParams.includes(listing.propertyType)) return false;
			}

			if (
				filters.beds &&
				filters.beds !== 0 &&
				(listing.bedrooms === undefined ||
					listing.bedrooms === null ||
					listing.bedrooms < filters.beds)
			)
				return false;

			if (
				filters.baths &&
				filters.baths !== 0 &&
				(listing.totalBathrooms === undefined ||
					listing.totalBathrooms === null ||
					listing.totalBathrooms < filters.baths)
			)
				return false;

			if (filters.status && listing.status !== filters.status) return false;

			return true;
		});
	});
</script>

<SalesListingsGrid listings={filteredListings}>
	{#each filteredListings as listing (listing.slug)}
		<SalesListingCard {listing} />
	{/each}
</SalesListingsGrid>
